/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-max-props-per-line */
import {Card} from 'primereact/card';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import StringUtils from '../../utils/StringUtils';
import {FaBiking} from 'react-icons/fa';
import {SelectButton} from 'primereact';
import {directions} from '../../utils/Direction';
import {DirectionType} from '../../model/enum/DirectionType';
import { t } from 'i18next';

export const DashboardCardMonthComponent = ({title, className, imageHref, resultValue, unit, percentageDeviation, resultValueColor}) => {
    const renderFooter = () => {
        if (!StringUtils.isBlank(percentageDeviation)) {
            const charBeforeValue = percentageDeviation < 0 ? '-' : '+';
            const color = percentageDeviation < 0 ? 'red' : 'green';

            return (
                <div className='footer'>
                    <span className={`percentage-deviation ${color}`}>
                        {charBeforeValue}
                        {Math.abs(percentageDeviation)}%
                    </span>{' '}
                    <span className='percentage-deviation-text'>{t('dashboard.prevous-month')}</span>
                </div>
            );
        }
    };
    const renderImage = () => {
        if (imageHref) {
            return (
                <div className='image'>
                    <img src={imageHref} style={{maxWidth: '140px'}} alt='obrazek'></img>
                </div>
            );
        }
    };

    return (
        <Card
            className='dashboard-card mt-4'
            title={title}
            // header={
            //     <div>
            //         <span>
            //             <SelectButton
            //                 optionLabel='name'
            //                 // value={direction}
            //                 options={directions}
            //                 onChange={(e) => {}}
            //             />
            //         </span>
            //     </div>
            // }
            footer={renderFooter}
        >
            <div className='row'>
                <div className='col-8'>
                    <div className='reuslt-value' style={{color: resultValueColor}}>
                        {resultValue} {unit}
                    </div>
                </div>
                <div className='col-4'>{renderImage()}</div>
            </div>
        </Card>
    );
};

DashboardCardMonthComponent.defaultProps = {};

DashboardCardMonthComponent.propTypes = {
    imageHref: PropTypes.string,
    title: PropTypes.string,
};

export default withTranslation()(DashboardCardMonthComponent);
